// extracted by mini-css-extract-plugin
export var buttons = "buttons-module--buttons--uBLn5";